import React from 'react'
import { any, AsyncState, fromJSX, Widget } from 'widgets-for-react'
import { userType } from '../../../subscription/subscriptionApi'
import { UserSubscriptions } from '../../../subscription/subscriptionState'
import { DataLayer, initializePIIData, PIIData } from '../../../utils/datalayer'
import { ComponentDidMount } from '../../../utils/lifecycleMethods'
import { PaywallLayout, PreFooterCtaLayout } from './paywallLayout'

export const paywallWidget = (
  isLoggedIn: boolean,
  userSubscriptionState: AsyncState<UserSubscriptions>,
  allowedSubscriptionIds?: number[],
  fade: boolean = true,
  layoutType: 'paywall' | 'preFooterCta' = 'paywall'
) => {
  const type = userType(userSubscriptionState)
  // The willExpire check doesn't tell us the previous subscription of a user.
  // We need this data from the TerminatedSubscription field in Sharepoint/Es but is currently not given to the frontend
  // As we dont have the subscription id, we cannot match it with the allowed subscription ID's
  // For the logic, see GetSubscriptionTypeIdsFromSession in the SubscriptionService
  const willExpire =
    userSubscriptionState.kind == 'loaded' &&
    userSubscriptionState.value.PaywallStatus ==
      'StillValidTerminatedSubscription';

  const piiData = initializePIIData(userSubscriptionState);
  
  // Temporarily disable the subscription type check for the Stripe migration
  // - This functionality is allegedly not used at the moment
  // - Subscription data is not received at this moment
  // - Subscription identifiers between Hoppinger subscription and Stripe will not match
  const blockContentBySubscriptionType = false;
  /*
  const blockContentBySubscriptionType = userSubscriptionState.kind == 'loaded' &&
  allowedSubscriptionIds &&
  !userSubscriptionState.value.ActiveSubscription.some((activeSubscription) =>
    allowedSubscriptionIds.includes(activeSubscription.Subscription.Id)
  )
  */
  const datalayerActionValue =
    window.location.pathname.split('/').length >= 2
      ? window.location.pathname.split('/')[2]
      : ''
  return <A,>(
    paywalledWidget: Widget<A>,
    notPaywalledWidget: Widget<A>
  ): Widget<A> =>
    isLoggedIn
      ? (type == 'expired' || blockContentBySubscriptionType) &&
        //an account that expires never sees a paywall
        !willExpire &&
        //students and teachers never see a paywall
        !(type == 'student') &&
        !(type == 'teacher')
        ? any<A>([
            paywalledWidget,
            fromJSX(() =>
              layoutType == 'paywall' ? (
                <>
                  <ComponentDidMount
                    onMount={() => DataLayer.showPaywall(datalayerActionValue)}
                  />
                  <PaywallLayout.Subscribe piiData={piiData} hasFade={fade} />
                </>
              ) : (
                <PreFooterCtaLayout.Subscribe />
              )
            ),
          ])
        : notPaywalledWidget
      : any<A>([
          paywalledWidget,
          fromJSX(() =>
            layoutType == 'paywall' ? (
              <>
                <ComponentDidMount
                  onMount={() => DataLayer.showPaywall(datalayerActionValue)}
                />
                <PaywallLayout.Register piiData={piiData} hasFade={fade} />
              </>
            ) : (
              <PreFooterCtaLayout.Register />
            )
          ),
        ])
}
